import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M2.047 6.762h20.429M22.476 3.095v7.334M1.524 3.095v7.334M19.334 1v11.524M4.667 1v11.524" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>);